// extracted by mini-css-extract-plugin
module.exports = {"features-section":"FeaturesItemsSection_features-section__yoR9r","full-list":"FeaturesItemsSection_full-list__DOSxZ","features-list":"FeaturesItemsSection_features-list__PiM5n"};